import * as actions from "./actionsTypes";

const initialData = {
  loaderDocs: false,
  loaderDoc: false,
  saveLoaderDoc: false,
  docs: null,
  doc: null,
  docsFaild: null,
  docFaild: null,
  formDocsFaild: null  
};

export default function SancionesDocsReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADER_SANCIONES_DOCS:
      return { ...state, loaderDocs: action.payload };
    case actions.LOADER_SANCIONES_DOC:
      return { ...state, loaderDoc: action.payload };
    case actions.SAVE_LOADER_SANCIONES_DOC:
      return { ...state, saveLoaderDoc: action.payload };
    case actions.GET_SANCIONES_DOCS:
      return { ...state, docs: action.payload };
    case actions.GET_SANCIONES_DOC:
      return { ...state, doc: action.payload };
    case actions.FAILD_SANCIONES_DOCS:
      return { ...state, docsFaild: action.payload }
    case actions.FAILD_SANCIONES_DOC:
      return { ...state, docFaild: action.payload };
    case actions.FORM_SANCIONES_DOC_FAILD:
      return { ...state, formDocsFaild: action.payload };
    default:
      return state;
  }
}